import PlatformAdvancedView from './PlatformAdvancedView'

export default PlatformAdvancedView
